import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { imageUrl, srcSet } from '../lib/images';

export default function Home() {
  const [articles, setArticles] = useState([]);

  // Fetch articles from CMS or fallback to default seeded articles
  useEffect(() => {
    async function loadArticles() {
      try {
        const res = await fetch('/_api/public/v2/content/nyheder?limit=3');
        if (res.ok) {
          const data = await res.json();
          if (data.items && data.items.length > 0) {
            setArticles(data.items);
          }
        }
      } catch {
        // Fallback handled below
      }
    }
    loadArticles();
  }, []);

  const defaultArticles = [
    {
      slug: 'eksempel-paa-indlaeg-2-2-2',
      title: 'Eksempel på indlæg',
      resume: 'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      billede: ['custom-size-6.jpg'],
    },
    {
      slug: 'eksempel-paa-indlaeg-2-2',
      title: 'Eksempel på indlæg',
      resume: 'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      billede: ['custom-size-6.jpg'],
    },
    {
      slug: 'eksempel-paa-indlaeg-3',
      title: 'Eksempel på indlæg',
      resume: 'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      billede: ['custom-size-6.jpg'],
    },
  ];

  const displayedArticles = articles.length > 0
    ? articles.map((item) => ({
        slug: item.slug?.da || item.slug || item.id,
        title: item.data?.title || item.title || 'Eksempel på indlæg',
        resume: item.data?.resume || item.resume || 'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
        billede: item.data?.billede || item.billede || ['custom-size-6.jpg'],
      }))
    : defaultArticles;

  return (
    <div>
      <SEO
        title="Forside - Advokatfirmaet Kopp"
        description="Advokatfirma med fokus på miljø og bæredygtighed – målrettet rådgivning om krav til byggeri og infrastruktur Fagområder Kontakt Fagområder Rådgivning om håndtering af miljø- og bæredygtighedsretlige krav relateret til regulering og myndighedsbehandling i forbindelse med ændret anvendelse af arealer på land eller hav."
        ogImage={imageUrl('environmental-protection-326923-1920-1024x683.jpg')}
      />

      {/* 1. Hero Section */}
      <section className="relative w-full min-h-[580px] lg:min-h-[640px] flex items-center bg-[#1c3848] overflow-hidden">
        {/* Background Image with overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('https://assets.auxodev.dk/assets/e3b6e513-d5b0-412a-bc42-41d1a7d57a1c/imgi-23-titti-04-v2.webp', 'width=1920,quality=85,format=auto')}
            srcSet={srcSet('https://assets.auxodev.dk/assets/e3b6e513-d5b0-412a-bc42-41d1a7d57a1c/imgi-23-titti-04-v2.webp')}
            sizes="100vw"
            alt="Advokatfirmaet Kopp kontor"
            className="w-full h-full object-cover max-md:[object-position:48%_20%] md:object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1c3848]/90 via-[#1c3848]/75 to-transparent" />
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-[1400px] w-full mx-auto px-6 lg:px-12 py-20 lg:py-28">
          <div className="max-w-2xl text-white space-y-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight">
              Advokatfirma med fokus på miljø og bæredygtighed
            </h1>
            <p className="text-lg sm:text-xl lg:text-2xl text-slate-200 font-light leading-relaxed">
              - målrettet rådgivning om krav til byggeri og infrastruktur
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 pt-6 w-full sm:w-auto">
              <Link
                to="/fagomraader/"
                className="text-center px-8 py-3.5 border border-white text-white hover:bg-white hover:text-[#1c3848] text-xs uppercase tracking-widest font-semibold rounded-none transition-colors w-full sm:w-auto"
              >
                Fagområder
              </Link>
              <Link
                to="/kontakt/"
                className="text-center px-8 py-3.5 border border-white text-white hover:bg-white hover:text-[#1c3848] text-xs uppercase tracking-widest font-semibold rounded-none transition-colors w-full sm:w-auto"
              >
                Kontakt
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Fagområder Teaser */}
      <section className="w-full bg-white py-20 lg:py-28 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 space-y-6">
            <h2 className="text-3xl lg:text-4xl font-bold text-[#34657f]">
              Fagområder
            </h2>
            <div className="space-y-4 text-sm text-slate-600 leading-relaxed">
              <p>
                Rådgivning om håndtering af miljø- og bæredygtighedsretlige krav relateret til regulering og myndighedsbehandling i forbindelse med ændret anvendelse af arealer på land eller hav.
              </p>
              <p>
                Rådgivningen omkring miljø- og bæredygtighedsretten kan være knyttet til med en bygherres etablering og drift af byggeri og infrastruktur, gennemførelse af private transaktioner, myndighedsudøvelse fra eller af offentlige myndigheder osv.
              </p>
            </div>
            <div className="pt-2">
              <Link
                to="/fagomraader/"
                className="inline-block px-8 py-3.5 bg-[#34657f] hover:bg-[#2a5267] text-white text-xs font-semibold uppercase tracking-widest rounded-none transition-colors"
              >
                Se alle fagområder her
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="overflow-hidden shadow-sm">
              <img
                src={imageUrl('environmental-protection-326923-1920-1024x683.jpg', 'width=1000,height=700,fit=cover,quality=85,format=auto')}
                alt="Miljøbeskyttelse og bæredygtighed"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 3. Min vision Section (Deep teal #347c80) */}
      <section className="w-full bg-[#347c80] text-white py-20 lg:py-28 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="w-full h-full flex justify-center items-center">
            <div className="w-full h-full shadow-2xl overflow-hidden">
              <img
                src={imageUrl('titti-02-til-om-mig-forside-lidt-mindre.webp', 'width=1200,quality=90,format=auto')}
                alt="Titti Kopp, Advokat, Ph.d."
                className="w-full h-full min-h-[420px] lg:min-h-[520px] object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="space-y-6">
            <h2 className="text-3xl lg:text-4xl font-bold text-white">
              Min vision
            </h2>

            <blockquote className="text-base sm:text-lg text-teal-50 font-normal leading-relaxed border-l-2 border-teal-300 pl-4 my-4">
              ”Min rådgivning skal give mine klienter <strong>kendskab og bistand</strong> til håndtering af de miljø- og bæredygtighedsretlige krav til deres aktiviteter som bygherre eller myndighed, så de kan <strong>træffe bevidste valg</strong> om <strong>imødegåelse af tab</strong>”
            </blockquote>

            <div className="space-y-3 pt-2">
              <h3 className="text-base font-bold text-white uppercase tracking-wider">
                Erfaringer & Kompetencer
              </h3>
              <p className="text-xs sm:text-sm text-teal-100 font-medium">
                Advokat, Ph.d. fra Århus Universitet i miljø og forvaltningsret
              </p>
              <p className="text-xs sm:text-sm text-teal-100 font-medium pt-1">
                CV (uddrag);
              </p>

              <ul className="space-y-2 text-xs sm:text-sm text-teal-50 leading-relaxed pt-1">
                <li className="flex items-start space-x-2">
                  <span className="text-teal-300 font-bold">→</span>
                  <span>Direktør for miljøjura og bæredygtighed og projektchef for forundersøgelse af Als-Fyn forbindelsen, Projektudvikling, Sund & Bælt Holding A/S</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-teal-300 font-bold">→</span>
                  <span>Chef for jura og miljø, Kattegatprojektet, Sund & Bælt Holding A/S</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-teal-300 font-bold">→</span>
                  <span>Advokat, Director, Head of Environment, Lundgrens Advokatpartnerselskab</span>
                </li>
                <li className="flex items-start space-x-2">
                  <span className="text-teal-300 font-bold">→</span>
                  <span>General Counsel, Tilladelser & Offentlig ret, Femern A/S</span>
                </li>
              </ul>
            </div>

            <div className="pt-4">
              <Link
                to="/om-mig/"
                className="inline-block px-8 py-3.5 bg-white text-[#347c80] hover:bg-slate-100 text-xs font-semibold uppercase tracking-widest rounded-none transition-colors"
              >
                Læs mere om mig
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
